import React, { useState } from 'react';
import { Card, Tabs } from '../../components/common';
import { useAuth } from '../../context/AuthContext';
import GeneralTab from './GeneralTab';
import UsersTab from './UsersTab';
import UserGroupsTab from './UserGroupsTab';
import DocumentSeriesTab from './DocumentSeriesTab';
import OpenPeriodTab from './OpenPeriodTab';

const TABS = [
  { key: 'general', label: 'General' },
  { key: 'users', label: 'Users' },
  { key: 'groups', label: 'User Groups' },
  { key: 'series', label: 'Document Series' },
  { key: 'period', label: 'Open Period' },
];

export default function SettingsPage({ onToast }) {
  const { can } = useAuth();
  const [tab, setTab] = useState('general');

  if (!can('SETTINGS', 'CanView')) {
    return (
      <Card title="Settings">
        <p className="py-6 text-center text-sm text-gray-500">
          You don’t have permission to view Settings.
        </p>
      </Card>
    );
  }

  return (
    <Card title="Settings">
      <Tabs tabs={TABS} value={tab} onChange={setTab} />
      {tab === 'general' && <GeneralTab onToast={onToast} />}
      {tab === 'users' && <UsersTab onToast={onToast} />}
      {tab === 'groups' && <UserGroupsTab onToast={onToast} />}
      {tab === 'series' && <DocumentSeriesTab onToast={onToast} />}
      {tab === 'period' && <OpenPeriodTab onToast={onToast} />}
    </Card>
  );
}
